import { CAR_DETAIL_IMAGE_LABEL } from '@encarpkg/shared';
import dayjs from 'app/libs/dayjs';

const imgServerURL = process.env.REACT_APP_IMG_SERVER;

const ci = '/wt_mark/w_mark_04.png';

export const cdnAliasMobileList = `impolicy=heightRate&rh=480&cw=640&ch=480&cg=Center&wtmk=${imgServerURL}${ci}`;
export const cdnAliasMobileListPremium = `impolicy=heightRate&rh=480&cw=640&ch=480&cg=Center&wtmk=${imgServerURL}${ci}`;
export const cdnAliasMobileDetailView = `impolicy=heightRate&rh=480&cw=640&ch=480&cg=Center&wtmk=${imgServerURL}${ci}`;
export const cdnAliasMobileDetailView_Ratio5x3 = `impolicy=heightRate&rh=384&cw=640&ch=384&cg=Center&wtmk=${imgServerURL}${ci}`;
export const cdnAliasMobileSelfReview = 'downsize=180px:*&crop=130px:130px;*,*';

// 썸네일은 제외, 오름차순 정렬
export const carDetailImageFilter = (items) => {
	const exceptThumnail = items?.filter((item) => item.type !== 'THUMBNAIL');
	const sortAsc = exceptThumnail && exceptThumnail.sort((a, b) => Number(a.code) - Number(b.code));
	return sortAsc;
};

export const carDetailImage = (path, cache) => {
	const inCache = cache ? `&t=${dayjs(cache).format('YYYYMMDDHHmmss')}` : '';
	return `${imgServerURL}/carpicture${path}?${cdnAliasMobileDetailView}${inCache}`;
};

export const carDetailImage_Ratio5x3 = (path, cache) => {
	const inCache = cache ? `&t=${dayjs(cache).format('YYYYMMDDHHmmss')}` : '';
	return `${imgServerURL}/carpicture${path}?${cdnAliasMobileDetailView_Ratio5x3}${inCache}`;
};

export const sellerProfileImage = (path) => `${imgServerURL}${path}?resize=160px:160px${`&t=${dayjs().format('YYYYMMDDHHmm')}`}`;

// 차량상세 PC 4컷 썸네일 코드 (뒷측면, 전면, 후면, 실내)
const CAR_DETAIL_IMAGE_THUMBNAIL_4CUT = ['002', '003', '004', '007'];
// 4컷 썸네일 목록(이미지가 없으면 CAR_DETAIL_IMAGE_LABEL순으로 다음 이미지로 교체)
export const carDetailImageThumbnail4Cut = (photos) => {
	const photoList = photos ?? [];
	const thumbnailCheckList = Object.keys(CAR_DETAIL_IMAGE_LABEL);
	const usedCodes = new Set();
	const findPhoto = (code) => photoList.find((item) => String(item.code) === code);

	return CAR_DETAIL_IMAGE_THUMBNAIL_4CUT.map((code) => {
		let resolvedCode = code;
		let photo = findPhoto(code);
		if (!photo) {
			const nextCodes = thumbnailCheckList.slice(thumbnailCheckList.indexOf(code) + 1);
			const fallbackCode = nextCodes.find((next) => !CAR_DETAIL_IMAGE_THUMBNAIL_4CUT.includes(next) && !usedCodes.has(next) && findPhoto(next));
			if (fallbackCode) {
				resolvedCode = fallbackCode;
				photo = findPhoto(fallbackCode);
			}
		}
		usedCodes.add(resolvedCode);
		return {
			code: resolvedCode,
			alt: CAR_DETAIL_IMAGE_LABEL[resolvedCode] ?? '',
			path: photo?.path,
			updateDateTime: photo?.updateDateTime,
		};
	});
};
